import { adminApi } from "src/api";
import { ApiControllers } from "src/api/config";

const getKpiData = (url) => {
    return adminApi.get(ApiControllers.reportsService + `${url}`)
}
const getKpis = (url) => {
    return adminApi.get(ApiControllers.caseManagement + `${url}`)
}
const getPieChartData = () => {
    const url = 'CardsPieChart'
    return adminApi.get(ApiControllers.reportsService + `${url}`)
}
const getBalancesChartData = () => {
    const url = 'CardsBalancesBarGraph'
    return adminApi.get(ApiControllers.reportsService + `${url}`)
}
const getTransactionsLineChartData = (filters) => {
    const url = 'CardsTransactionsLineGraph/'
    const currDate = new Date();
    return adminApi.get(ApiControllers.reportsService + `${url}` + (filters?.year || currDate.getFullYear()))
}
const getTransactionsChartData = (filters) => {
    const url = 'CryptoTransactionsGraph/'
    const currDate = new Date();
    return adminApi.get(ApiControllers.reportsService + `${url}` + (filters?.year || currDate.getFullYear()))
}
const getYearLookup = () => {
    return adminApi.get(ApiControllers.reportsService + 'yearsLookUp')
}
const getDaysLookup = () => {
    return adminApi.get(ApiControllers.caseManagement + 'GraphLu')
}
const getActivity = (days, pageSize, pageNo) => {
    return adminApi.get(ApiControllers.caseManagement + `GetRecentActivity/${days}/${pageSize}/${pageNo}`)
}
const getCardsStates = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/CardsStates/${days}`)
}
const getActiveCards = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/Cards/${days}`)
}
const getKycStates = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/customerStates/${days}`)
}
const getOnboardingCustomers = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/ActiveCustomers/${days}`)
}
const getTopupCardsTransctionsChartData = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/cardTopupTransaction/${days}`)
}

const getConsumeCardsTransctionsChartData = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/allTransactions/${days}`)
}
const getMerchantChartData = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/MerchnatBalance/${days}`)
}
const getCardsTopUpChartData = (days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/CardToupBalance/${days}`)
}
const getProgramWiseTopUpChart = (programId, days) => {
    return adminApi.get(ApiControllers.caseManagement + `Graph/ProgramToupBalance/${programId}/${days}`)
}
export {
    getKpiData, getPieChartData, getTransactionsChartData, getBalancesChartData, getYearLookup, getTransactionsLineChartData,
    getKpis, getActivity, getCardsStates, getKycStates, getOnboardingCustomers, getActiveCards, getTopupCardsTransctionsChartData, getConsumeCardsTransctionsChartData,
    getMerchantChartData, getCardsTopUpChartData, getDaysLookup, getProgramWiseTopUpChart
}